import { useTranslation } from 'react-i18next';

export default function SpreadsheetIntro() {
  const { t } = useTranslation();

  return (
    <section className="py-12 md:py-16 bg-stone-50">
      <div className="w-full px-4 md:px-6 lg:px-8">
        <div className="max-w-3xl mx-auto text-center">
          <h2 className="text-2xl md:text-3xl font-bold text-stone-800 mb-4 md:mb-6">
            {t('spreadsheet_intro_h2')}
          </h2>
          <p className="text-sm md:text-base text-stone-600 leading-relaxed mb-6 md:mb-8">
            {t('spreadsheet_intro_text')}
          </p>
          <a
            href="/cssbuy-spreadsheet/"
            className="inline-flex items-center gap-2 px-5 py-2.5 text-sm font-medium text-emerald-700 bg-emerald-50 rounded-lg hover:bg-emerald-100 transition-colors"
          >
            {t('spreadsheet_intro_cta')}
            <i className="ri-arrow-right-line" />
          </a>
        </div>
      </div>
    </section>
  );
}